export default __webpack_public_path__ + "assets/cce1e9f06e944133fb0b72d4b5c381cc.svg";